webpackJsonp([38],{

/***/ 1177:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1178);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(616).default
var update = add("dbd23d44", content, true, {});

/***/ }),

/***/ 1178:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(455)(true);
// imports


// module
exports.push([module.i, ".btn-delete[data-v-8bbb5066]{position:absolute;top:20px;right:0;height:31px;border-top-left-radius:0!important;border-bottom-left-radius:0!important}", "", {"version":3,"sources":["F:/myugfront/src/components/clubs/club-form.vue"],"names":[],"mappings":"AACA,6BACE,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,YAAa,AACb,mCAAqC,AACrC,qCAAwC,CACzC","file":"club-form.vue","sourcesContent":["\n.btn-delete[data-v-8bbb5066] {\n  position: absolute;\n  top: 20px;\n  right: 0;\n  height: 31px;\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"bg-light p-5 b-30 shadow-1"},[(_vm.loading)?_c('div',[_c('sk-list',{attrs:{"items-count":2,"height":0.04}})],1):_c('div',[(!_vm.rules || _vm.accepted)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t('clubs.club-information')))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('clubs.name')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"id":"name","type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('clubs.head-info')))]),_vm._v(" "),(_vm.form.head.personal_id==this.$store.state.auth.user.personal_code)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"headPersonalId"}},[_vm._v(_vm._s(_vm.$t('clubs.personal-id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.head.personal_id),expression:"form.head.personal_id"}],staticClass:"form-control",attrs:{"id":"headPersonalId","type":"text"},domProps:{"value":(_vm.form.head.personal_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.head, "personal_id", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"headMobile"}},[_vm._v(_vm._s(_vm.$t('clubs.mobile')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.head.mobile),expression:"form.head.mobile"}],staticClass:"form-control",attrs:{"id":"headMobile","type":"text"},domProps:{"value":(_vm.form.head.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.head, "mobile", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"headEmail"}},[_vm._v(_vm._s(_vm.$t('clubs.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.head.email),expression:"form.head.email"}],staticClass:"form-control",attrs:{"id":"headEmail","type":"text"},domProps:{"value":(_vm.form.head.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.head, "email", $event.target.value)}}})]),_vm._v(" "),(_vm.form.head.personal_id==this.$store.state.auth.user.personal_code)?_c('h3',[_vm._v("\n              "+_vm._s(_vm.$t('clubs.members'))+"\n              "),_c('button',{staticClass:"btn btn-primary-red-7 float-right",on:{"click":function($event){return _vm.addMember()}}},[_vm._v("+ დამატება")])]):_vm._e(),_vm._v(" "),(_vm.form.head.personal_id==this.$store.state.auth.user.personal_code)?_c('div',_vm._l((_vm.form.personal_ids),function(personalId,$i){return _c('div',{staticClass:"form-group position-relative"},[_c('label',{attrs:{"for":'memberPersonalId' + $i}},[_vm._v(_vm._s(_vm.$t('clubs.personal-id')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.personal_ids[$i]),expression:"form.personal_ids[$i]"}],staticClass:"form-control",attrs:{"id":'memberPersonalId' + $i,"type":"text"},domProps:{"value":(_vm.form.personal_ids[$i])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.personal_ids, $i, $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary-red-7 btn-delete",on:{"click":function($event){return _vm.removeMember($i)}}},[_vm._v("-")])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8 offset-lg-2"},[_c('h3',[_vm._v(_vm._s(_vm.$t('clubs.club-info')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"goal"}},[_vm._v(_vm._s(_vm.$t('clubs.goal')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.goal),expression:"form.goal"}],staticClass:"form-control",attrs:{"id":"goal"},domProps:{"value":(_vm.form.goal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "goal", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"governance_rules"}},[_vm._v(_vm._s(_vm.$t('clubs.governance-rules')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.governance_rules),expression:"form.governance_rules"}],staticClass:"form-control",attrs:{"id":"governance_rules"},domProps:{"value":(_vm.form.governance_rules)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "governance_rules", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"membership"}},[_vm._v(_vm._s(_vm.$t('clubs.membership')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.membership),expression:"form.membership"}],staticClass:"form-control",attrs:{"id":"membership"},domProps:{"value":(_vm.form.membership)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "membership", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"other_information"}},[_vm._v(_vm._s(_vm.$t('clubs.other-information')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.other_information),expression:"form.other_information"}],staticClass:"form-control",attrs:{"id":"other_information"},domProps:{"value":(_vm.form.other_information)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "other_information", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4"},[_c('b-form-file',{attrs:{"placeholder":_vm.$t('clubs.choose-logo')},model:{value:(_vm.form.file),callback:function ($$v) {_vm.$set(_vm.form, "file", $$v)},expression:"form.file"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 text-center mt-5"},[_c('button',{staticClass:"btn btn-primary-red",on:{"click":function($event){return _vm.handleSave()}}},[_vm._v(_vm._s(_vm.$t('clubs.save')))])])]):_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12 mb-3"},[_c('h3',[_vm._v(_vm._s(_vm.$t('clubs.rules')))])]),_vm._v(" "),_c('div',{staticClass:"col-12 font-16",domProps:{"innerHTML":_vm._s(_vm.rules)}}),_vm._v(" "),_c('div',{staticClass:"col-12 text-center mt-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accepted),expression:"accepted"}],attrs:{"id":"accept","type":"checkbox"},domProps:{"value":1,"checked":Array.isArray(_vm.accepted)?_vm._i(_vm.accepted,1)>-1:(_vm.accepted)},on:{"change":function($event){var $$a=_vm.accepted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=1,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.accepted=$$a.concat([$$v]))}else{$$i>-1&&(_vm.accepted=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.accepted=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"accept"}},[_vm._v(_vm._s(_vm.$t('clubs.accept')))])])])])])])])}
var staticRenderFns = []


/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_club_form_vue__ = __webpack_require__(860);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bbb5066_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_club_form_vue__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
function injectStyle (context) {
  __webpack_require__(1177)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bbb5066"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_club_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bbb5066_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_club_form_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bbb5066_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_club_form_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_clubResource__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__skeletons_sk_list__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(28);
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var resource = new __WEBPACK_IMPORTED_MODULE_0__api_clubResource__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'club-form',
  components: {
    SkList: __WEBPACK_IMPORTED_MODULE_1__skeletons_sk_list__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      form: this.emptyForm(),
      rules: null,
      accepted: false
    };
  },
  mounted: function mounted() {
    this.loadClubDetails();
  },
  methods: {
    handleSave: function handleSave() {
      var formData = new FormData();
      formData.append('name', this.form.name);
      formData.append('goal', this.form.goal);
      formData.append('governance_rules', this.form.governance_rules);
      formData.append('membership', this.form.membership);
      formData.append('other_information', this.form.other_information);
      formData.append('head[personal_id]', this.form.head.personal_id);
      formData.append('head[mobile]', this.form.head.mobile);
      formData.append('head[email]', this.form.head.email);

      var _iterator = _createForOfIteratorHelper(this.form.personal_ids),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pId = _step.value;
          formData.append('personal_ids[]', pId);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (this.form.file) formData.append('file', this.form.file);
      if (this.form.id) this.update(formData);else this.create(formData);
    },
    create: function create(formData) {
      var _this = this;

      resource.createClub(formData).then(function (resp) {
        _this.helpers.notifySuccessMessage(_this.$t('clubs.successfully-created'));

        _this.loadClubDetails();
      }).catch(function (err) {
        _this.helpers.notifyErrorMessage(err);

        setTimeout(function () {
          window.location.href = '/clubs';
        }, 2000);
      });
    },
    update: function update(formData) {
      var _this2 = this;

      resource.updateClub(this.form.id, formData).then(function (resp) {
        _this2.helpers.notifySuccessMessage(_this2.$t('clubs.successfully-updated'));

        _this2.loadClubDetails();
      }).catch(function (err) {
        _this2.helpers.notifyErrorMessage(err);
      });
    },
    addMember: function addMember() {
      this.form.personal_ids.push('');
    },
    removeMember: function removeMember(i) {
      this.form.personal_ids.splice(i, 1);
    },
    fillForm: function fillForm(data) {
      this.form.id = data.self_governmentID;
      this.form.name = data.club_name;
      this.form.personal_ids = data.personal_ids;
      this.form.head.personal_id = data.personal_ids[0];
      this.form.head.mobile = data.mob;
      this.form.head.email = data.email;
      this.form.goal = data.club_goals;
      this.form.governance_rules = data.manager;
      this.form.membership = data.cancellation;
      this.form.other_information = data.more;
    },
    emptyForm: function emptyForm() {
      return {
        id: null,
        name: '',
        personal_ids: [''],
        head: {
          personal_id: '',
          mobile: '',
          email: ''
        },
        goal: '',
        governance_rules: '',
        membership: '',
        other_information: '',
        file: null
      };
    },
    loadClubDetails: function loadClubDetails() {
      var _this3 = this;

      this.loading = true;
      resource.clubDetails().then(function (resp) {
        var data = resp.data.data;
        if (data.myClub) _this3.fillForm(data.myClub);else _this3.loadRules();
      }).finally(function () {
        _this3.loading = false;
      });
    },
    loadRules: function loadRules() {
      var _this4 = this;

      resource.rules().then(function (resp) {
        _this4.rules = resp.data.data.rules;
      });
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/38.027a5535b304dc44aa4c.js